import { useEffect, useState } from "react";
import { Pin, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { companion } from "@/context/CompanionAuthContext";
import { useCompanionAuth } from "@/context/CompanionAuthContext";
import { formatDateTime } from "./utils";

const CompanionNotices = () => {
  const { user } = useCompanionAuth();
  const isAdmin = user?.role === "admin";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { setItems((await companion.get("/notices")).data); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Remove this notice?")) return;
    try {
      await companion.delete(`/notices/${id}`);
      setItems((p) => p.filter((x) => x.id !== id));
    } catch { toast.error("Couldn't remove notice."); }
  };

  return (
    <div className="px-4 py-5" data-testid="companion-notices-page">
      <header className="mb-4">
        <p className="text-xs uppercase tracking-[0.22em] text-crest-gold font-medium">Notices</p>
        <h1 className="mt-1 font-display text-2xl font-bold text-crest-navy">Daily noticeboard</h1>
      </header>

      {loading ? (
        <div className="grid place-items-center py-20"><Loader2 className="h-7 w-7 animate-spin text-crest-green" /></div>
      ) : items.length === 0 ? (
        <div className="rounded-lg border border-dashed border-border bg-white p-8 text-center text-sm text-muted-foreground">
          No notices yet.
        </div>
      ) : (
        <ul className="space-y-3">
          {items.map((n) => (
            <li key={n.id} className={`rounded-lg border bg-white p-4 ${n.is_pinned ? "border-crest-gold/40 bg-crest-gold/5" : "border-border"}`}
                data-testid={`notice-${n.id}`}>
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1.5">
                    {n.is_pinned && <Pin className="h-3.5 w-3.5 text-crest-gold" />}
                    <h2 className="font-display font-semibold text-crest-navy">{n.title}</h2>
                  </div>
                  <div className="mt-1 text-[11px] uppercase tracking-[0.14em] text-muted-foreground">
                    {n.poster_name} · {formatDateTime(n.created_at)}
                  </div>
                  <p className="mt-2 text-sm text-crest-navy/85 whitespace-pre-wrap">{n.body}</p>
                </div>
                {isAdmin && (
                  <button onClick={() => del(n.id)} aria-label="Delete notice" data-testid={`delete-notice-${n.id}`}
                          className="h-8 w-8 grid place-items-center rounded text-destructive">
                    <Trash2 className="h-4 w-4" />
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CompanionNotices;
